import { PROJECT_ROLES } from "@sperrdatei/dto/roles";

import type { PROJECT_ROLE } from "@sperrdatei/dto/roles";
import type { JSX } from "react";

type RoleBadgeProps = {
  roleKey: PROJECT_ROLE["key"];
};

const getBadgeClass = (roleKey: PROJECT_ROLE["key"]): string => {
  switch (roleKey) {
    case "ADMIN":
    case "INSTITUTE_ADMIN":
      return "badge bg-danger";
    case "FILE_DOWNLOAD":
    case "FILE_UPLOAD":
    case "NUMBER_ADD":
    case "NUMBER_VERIFY":
    case "API_ACCESS":
      return "badge text-bg-secondary";
  }
};

export const RoleBadge = ({ roleKey }: RoleBadgeProps): JSX.Element => {
  const role = PROJECT_ROLES.find((role) => role.key === roleKey);

  return (
    <span key={roleKey} className={`badge ${getBadgeClass(roleKey)} small`}>
      {role ? role.displayName : roleKey}
    </span>
  );
};
